import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export const Container = styled.div({
  alignItems: 'flex-end',
  display: 'flex',
});

// Override AK so the button height matches that of the text field
export const CopyButtonToMatchTextfield = styled.div({
  marginLeft: token('space.100'),
  '& button': {
    height: '39px',
  },
});

export const TextField = styled.div({
  flex: 1,
});
